import $ from 'jquery';
import run from '../../utilities/run';
import {isPresent, isBlank} from '../../utilities/general'
import render from "../../utilities/render";
import QuickWizard from '../../components/QuickWizard/QuickWizard';
import EbayReviewTab from './ebayReviewTab';
import EbayConnectionsTab from './ebayConnectionsTab';
import EbayConfigurationsTab from './ebayConfigurationsTab';

run("#create-ebay-channel-form", ()=> {
const el = $("#create-ebay-channel-form");
attachWizard(el);
setupEditChecker();
});

function setupEditChecker(){
  EditChecker.bindNavigation();
  EditChecker.bindChangeListener("#create-ebay-channel-form");
  EditChecker.bindCancelButton("#create-ebay-channel-cancel-btn");
}

function attachWizard(el){
  const wizardElement=el;

  const validator = el.validate({
    errorPlacement: function(error, element) {
      let appendClosest = $(element).data('error-placement-append-closest');
      if (appendClosest) {
        $(element).closest(appendClosest).append(error);
      } else {
        error.insertAfter(element);
      }
    }
    // Place all your validation rules here!!!
    // rules: {

    // }
  });

  validator.settings.ignore = ":disabled,:hidden";


  const quickWizard = new QuickWizard(el, {
    tabletWidthNavStep: 902,
    mobileWidthNavStep: 502,

    // customRules: {

    // },
    shouldNavigateToForm: ({targetForm, direction, currentForm, done})=>{
      //return true;
     // Any time we go traverse backwards, just let us
      if(direction === "BACKWARDS"){
        return true;
      }

         // handle general validations on forward traversal
      let allPrevInputs = quickWizard.allPreviousFieldsUpToTargetForm(targetForm);
      if (targetForm.filter('.configurations-tab').length || targetForm.filter('.review-tab').length) {
        return connectionTab.areInputsValidForForm();
      } else if(!quickWizard.areInputsValid(allPrevInputs, {displayErrors: true})){
        quickWizard.goToFirstIncompleteForm();
        return false;
      }
    },
    didNavigateToForm: function({currentForm}){
       if(currentForm.filter('.connections-tab').length){
         connectionTab.didNavigateToForm();
       }else if(currentForm.filter('.configurations-tab').length){
         configurationTab.didNavigateToForm();
       }else if(currentForm.filter('.review-tab').length){
         reviewTab.didNavigateToForm();
       }
    }

  });

quickWizard.init();

function canSave(quickWizard){
  const currentForm = quickWizard.getActiveTargetForm();
    let isValid = true;
    if(currentForm.filter(".connection-tab").length){
       isValid = areInputsValidForForm(currentForm);
     }
   return isValid;
}

const connectionTab = new EbayConnectionsTab(quickWizard);
connectionTab.init();


const configurationTab = new EbayConfigurationsTab(quickWizard);
configurationTab.init();

const reviewTab = new EbayReviewTab(quickWizard);
reviewTab.init();
}



// WEBPACK FOOTER //
// ./src/pages/createChannel/createEbayChannel.js